export const APPLICATION = 'MathNation';

export enum MnLoginErrorCodes {
  MFA_REQUIRED = 'MFA_CODE_REQUIRED',
  ACCOUNT_DEACTIVATED = 'ADOPTION_ACCOUNT_DEACTIVATED_MANUALLY',
  INVALID_CREDENTIALS = 'INVALID_CREDENTIALS',
}
